import { Analytics } from "../common/Analytics";

export const analyticsMiddleware = (store) => (next) => (action) => {
	if (action.meta && action.meta.analytics) {
		const {
			"data-eventreg": dataEventReg,
			"data-eventstep": dataEventStep,
			"data-eventtitle": dataEventTitle,
			"data-eventfield": dataEventField,
			"data-eventline": dataEventLine
		} = action.meta.analytics;
		Analytics.push(
			dataEventReg,
			dataEventStep,
			dataEventTitle,
			dataEventField,
			dataEventLine
		);
	}

	next(action);
};
